<template>
  <div class="wraper">
    <el-row class='top'>
      <span>订单详情</span>
      <el-date-picker
        size='mini'
        v-model="date"
        type="daterange"
        align="right"
        unlink-panels
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :clearable='clearDate'
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <el-input
        v-model="search"
        size="mini"
        placeholder="设备ID"
        clearable
        class='search'
        width='200'
        @keyup.enter.native="searchTable"
      ></el-input>
      <el-button size="mini" type="primary" @click='searchTable'>查询</el-button>
      <!--       <div class="export_btn">
              <exporter
                :setting='setting'
                :url='getListUrl'
                :date='date'
              ></exporter>
            </div> -->
    </el-row>
    <el-row>
      <el-table
        ref="filterTable"
        :data="list"
        style="width: 100%">
        <el-table-column
          label="序号"
          width="62px"
          type="index"
        ></el-table-column>
        <el-table-column
          prop="assetsNum"
          label="资产编码"
        >
        </el-table-column>
        <el-table-column
          prop="inspection_data_str"
          label="纯净度"
        >
        </el-table-column>
        <el-table-column
          prop="customer_flow_int"
          label="累计客流量"
        >
        </el-table-column>
        <el-table-column
          prop="floor"
          label="照片"
        >
          <template slot-scope="scope">
            <el-popover
              placement="right"
              title=""
              trigger="hover">
              <img :src="scope.row.inspection_image_base64" style="max-height: 550px;max-width: 530px"/>
              <img slot="reference" :src="scope.row.inspection_image_base64" :alt="scope.row.inspection_image_base64"
                   style="max-height: 100px;max-width: 260px">
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="sell_data_dict"
          width="600px"
          label="销售详情">
          <template slot-scope="scope">
            <template v-for='item in scope.row.sell_data_dict'>
              <div >
                <li >{{item.sellDate}}点</li>
                <div>
                  <template v-for="record in  item.sellDataList">
                    <ul><span class="grey">{{record.sellGoodsName}} 数量:  </span><span class="red">{{record.sellNum}}</span></ul>
                  </template>
                </div>
              </div>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-row class="pages">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[1,10,20,50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-row>
    </el-row>
  </div>
</template>

<script>
    import Report from '../../components/Report'
    import exporter from '../../components/exporter'

    export default {
        name: 'results',
        components: {
            Report,
            exporter
        },
        data() {
            return {
                getListUrl: 'data/getMlMainList',
                date: this.getDefaultDay(),
                clearDate: false,
                search: '',
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                    shortcuts: [{
                        text: '昨天',
                        onClick(picker) {
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', [start, start]);
                        }
                    }, {
                        text: '最近七天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                currentPage: 1,
                list: [],
                total: 0,
                pageSize: 10
            }
        },
        mounted() {
            this.getList();
        },
        methods: {
            getDefaultDay() {
                let date = new Date();
                let startdate = new Date(date.getTime() - 1000 * 60 * 60 * 24 * 8);
                let startyear = startdate.getFullYear();
                let startmonth = startdate.getMonth() + 1;
                if (startmonth < 10) {
                    startmonth = "0" + startmonth;
                }
                let startday = startdate.getDate();
                if (startday < 10) {
                    startday = "0" + startday;
                }
                startdate = startyear + '-' + startmonth + '-' + startday;
                let enddate = new Date(date.getTime() - 1000 * 60 * 60 * 24);
                let endyear = enddate.getFullYear();
                let endmonth = enddate.getMonth() + 1;
                if (endmonth < 10) {
                    endmonth = "0" + endmonth;
                }
                let endday = enddate.getDate();
                if (endday < 10) {
                    endday = "0" + endday;
                }
                enddate = endyear + '-' + endmonth + '-' + endday;
                return [startdate, enddate];
            },
            getList() {
                let url = this.getListUrl;
                let params = {
                    startDay: this.date[0],
                    endDay: this.date[1],
                    pageSize: this.pageSize,
                    pageNum: this.currentPage,
                    assetsNum: this.search
                }
                let _this = this;
                this.$ajax.post(url, params)
                    .then(this.getListSucc)
                    .catch(function (res) {
                        _this.$message.error('哎呀~网络异常了呢');
                    })
            },
            getListSucc(res) {
                if (res.data && res.data.code === 200) {
                    const data = res.data.data;
                    //this.list = data.list;
                    var list = data.list;
                    this.list = this.formatData(list);
                    this.total = data.total;
                } else {
                    let errMsg = '未知错误'
                    if (res.data.msg) {
                        errMsg = res.data.msg;
                    }
                    this.$message.error(errMsg);
                }
            },
            formatData(list) {
                var data = list;
                if (data.length === 0) return arr;
                var arr = [];
                for (var i = 0; i < data.length; i++) {
                    var temp = {};
                    var row = data[i]
                    temp.assetsNum = row.assetsNum;
                    temp.createTime = row.orderTime;
                    var record = row.mlDto;
                    temp.customer_flow_int = record.customer_flow_int;
                    temp.inspection_data_str = record.inspection_data_str;
                    temp.inspection_image_base64 = record.inspection_image_base64;
                    temp.sell_data_dict = record.sellDataList;
                    arr.push(temp)
                }
                return arr;
            },
            searchTable() {
                this.getList();
            },
            handleSizeChange(val) {
                // console.log('每页 '+val+' 条');
                this.pageSize = val;
                this.currentPage = 1;
                this.getList()
                // console.log(this.pageSize);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getList()
            },
            handleSun() {

            }

        }
    }
</script>
<style scoped>
  .top {
    height: 50px;
  }

  .pages {
    padding-top: 10px;
    text-align: center;
  }

  .search {
    width: 240px;
  }

  .red {
    color: #f00;
  }

  .grey {
    padding-left: 10px;
    color: #999;
  }

  .banma {
    background: #fee;
  }

  .banma:nth-child(even) {
    background: #efe;
  }

  .banma .title {
    width: 2em;
    float: left;
    font-weight: bold
  }

  .banma .list {
    margin-left: 2em;
  }

  img {
    object-fit: cover;
  }
</style>



// WEBPACK FOOTER //
// src/pages/results/results.vue